module.exports = __webpack_public_path__ + "2516339970d710819585f90773aebe0a.png";